<mat-stepper
  ngClass="stepper-container"
  (click)="scrollToBottom()"
  id="testid"
  orientation="vertical"
  linear
  #stepper
  (selectionChange)="changeWizardStep($event)"
>
  <mat-step [completed]="employeeHasSignature">
    <ng-template matStepLabel>
      {{
        "workorder.signature-wizard.employee-signature" | translate
      }}</ng-template
    >
    <app-workorder-signature-pad
      #employeeSignature
      [(employeeHasSignature)]="employeeHasSignature"
    ></app-workorder-signature-pad>

    <div class="step-actions">
      <button mat-button matStepperNext [disabled]="!employeeHasSignature">
        {{ "workorder.signature-wizard.next" | translate }}
      </button>
      <button
        class="clear-button"
        (click)="clearEmployeeSignature()"
        mat-raised-button
      >
        {{ "workorder.signature-wizard.clear" | translate }}
      </button>
    </div>
  </mat-step>

  <mat-step [completed]="clientHasSignature && clientHasName">
    <ng-template matStepLabel>
      {{
        "workorder.signature-wizard.client-signature" | translate
      }}</ng-template
    >
    <div class="client-name-container">
      <label> {{ "workorder.signature-wizard.client-name" | translate }}</label>
      <label class="required-label">{{
        "workorder.signature-wizard.required-label" | translate
      }}</label>
    </div>
    <input
      class="client-name"
      matInput
      [formControl]="clientNameControl"
      (ngModelChange)="changeClientName()"
    />
    <app-workorder-signature-pad
      #clientSignature
      [(clientHasSignature)]="clientHasSignature"
    ></app-workorder-signature-pad>

    <div class="step-actions">
      <button mat-button matStepperPrevious>
        {{ "workorder.signature-wizard.back" | translate }}
      </button>
      <button
        mat-button
        matStepperNext
        [disabled]="!clientHasSignature || !clientHasName"
      >
        {{ "workorder.signature-wizard.next" | translate }}
      </button>
      <button
        class="clear-button"
        (click)="clearClientSignature()"
        mat-raised-button
      >
        {{ "workorder.signature-wizard.clear" | translate }}
      </button>
    </div>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>
      {{
        "workorder.signature-wizard.add-attachments" | translate
      }}</ng-template
    >
    <label class="observations-label">
      {{ "workorder.signature-wizard.observations" | translate }}</label
    >
    <textarea
      class="observations"
      [formControl]="observationsControl"
    ></textarea>

    <div class="button-container">
      <label class="upload-files">
        <input
          type="file"
          class="input_file"
          (change)="onFileSelected($event)"
          #fileUpload
          multiple
        />
        {{ "workorder.signature-wizard.attach-files" | translate }}
        <button class="attach-button" mat-fab (click)="fileUpload.click()">
          <mat-icon> attach_file</mat-icon>
        </button>
      </label>
    </div>

    <div class="uploaded-files-container">
      <p class="warning-message">
        {{ "workorder.signature-wizard.file-warning" | translate }}
      </p>

      <p class="uploaded-file" *ngFor="let f of uploadedFiles">
        <mat-icon (click)="removeFile(f)">close</mat-icon>
        <label>{{ f.name }}</label>
      </p>

      <p class="error-message" *ngIf="maximumSizeError">
        <mat-icon class="error-icon">error</mat-icon>
        {{ "workorder.signature-wizard.max-size-error" | translate }}
      </p>
      <p class="error-message" *ngIf="numberofFilesError">
        <mat-icon class="error-icon">error</mat-icon>
        {{ "workorder.signature-wizard.max-files-error" | translate }}
      </p>
    </div>

    <div class="step-actions">
      <button mat-button matStepperPrevious (click)="removeErrorMsg()">
        {{ "workorder.signature-wizard.back" | translate }}
      </button>
      <button mat-button matStepperNext (click)="removeErrorMsg()">
        {{ "workorder.signature-wizard.next" | translate }}
      </button>
    </div>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>{{
      "workorder.signature-wizard.resume" | translate
    }}</ng-template>
    <div class="step-actions">
      <ul>
        <div class="resume-header">
          <label>{{
            "workorder.signature-wizard.resume-day" | translate
          }}</label>
          <label>{{
            "workorder.signature-wizard.resume-hours" | translate
          }}</label>
        </div>
        <div class="days-container">
          <li *ngFor="let createdEmployeeVisit of employeeVisitsByDay">
            <label>{{
              createdEmployeeVisit.day | localizedDate : "dd MMMM, yyyy"
            }}</label>
            <label class="day-total-hours"
              >{{ createdEmployeeVisit.totalHours }}h</label
            >
          </li>
        </div>

        <div class="spacer"></div>
        <div class="total-hours">
          <label>Total</label>
          <label>{{ getEmployeeVisitsTotal() }}h</label>
        </div>
      </ul>
      <button mat-button matStepperPrevious>
        {{ "workorder.signature-wizard.back" | translate }}
      </button>
    </div>
  </mat-step>
</mat-stepper>
